import { Button, P } from "@components/primitives/input";
import { useUserProfile } from "@providers/profile";
import { SubscriptionStatus } from "@providers/profile/ProfileProvider.model";
import { Color } from "@styles/constants";
import { countryConfig } from "@utils/countryConfig";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { NonActiveSubscription } from "../Account.styled";
import { SubscriptionInactiveProps } from "./Subscription.model";

const ErrorMessage = styled.div`
  display: "flex";
  justify-content: "center";
  padding: 10px 0px 10px 0px;
  background-color: ${Color.red40};
  margin-top: 20px;
  font-size: 14px;
  color: ${Color.blackBrand};
`;

const SubscriptionInactive = ({ subscription, dispatchBilling }: SubscriptionInactiveProps) => {
  const [submitting, setSubmitting] = useState(false);
  const [statusText, setStatusText] = useState<string>();
  const [reactivateError, setReactivateError] = useState<string | null>();
  const [denied, setDenied] = useState(false);

  const {
    reactivateSubscription,
    profileState: { authToken, profile },
  } = useUserProfile();

  const { subscription_status } = subscription;
  const showButton = profile.subscription_tier === 0 || profile.subscription_tier === 1;

  useEffect(() => {
    switch (subscription_status) {
      case SubscriptionStatus.Canceled:
        setStatusText("Your subscription has been canceled.");
        break;
      case SubscriptionStatus.PastDue:
        setStatusText("Your subscription is past due.");
        break;
      case SubscriptionStatus.Unpaid:
        setStatusText("Your suscription is unpaid");
        break;
      default:
        setStatusText("Your subscription can not be found.");
    }
  }, [subscription_status]);

  const createSubscription = async () => {
    if (submitting) return;
    setSubmitting(true);

    try {
      const newSubscription = await reactivateSubscription(authToken);
      dispatchBilling((prevState) => ({ ...prevState, subscription: { ...newSubscription } }));
    } catch (e) {
      if (e.response?.errors?.error_code == "permission_denied") {
        setDenied(true);
      }
      setReactivateError("Payment failed, please update your billing information");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <NonActiveSubscription>
      <p>{statusText}</p>
      {showButton && (
        <>
          <Button data-testid="reactivate_subscription_button" onClick={createSubscription}>
            Reactivate Subscription
          </Button>
          <P size="small" align="center" style={{ marginTop: "10px" }}>
            Your card on file will be charged ${countryConfig().monthlySubCost} + taxes
          </P>
          {reactivateError && !denied ? (
            <ErrorMessage data-testid="reactivate-error-message">{reactivateError}</ErrorMessage>
          ) : null}
          {reactivateError && denied ? (
            <ErrorMessage data-testid="reactivate-error-message">
              <p className="small-text alert-text">
                We&apos;re sorry, this action is not allowed at this time. If you need additional
                support, please{" "}
                <a href="https://mirror.kustomer.help/contact/contact-us-r186OoIXY">
                  contact our support team
                </a>
                .
              </p>
            </ErrorMessage>
          ) : null}
        </>
      )}
    </NonActiveSubscription>
  );
};

export default SubscriptionInactive;
